<span (click)="update()">
  <ng-container *ngIf="shellAppConfig.appVersion"
    >{{ shellAppConfig.appVersion }} /
  </ng-container>
  v{{ version }}
</span>
